import RecommendationsTables from './container';

export default RecommendationsTables;



// WEBPACK FOOTER //
// ./src/routes/RecommendationsTables/index.js